import { useEffect, useState } from "react";
import stripe from "../assets/stripe.svg";
import tick from "../assets/tick.svg";
import Modal from "antd/lib/modal";
import notification from "antd/lib/notification";
import { useSelector } from "react-redux";
import { usePaystackPayment } from "react-paystack";
import FullModal from "../components/FullModal";
import { paystack_key } from "../components/menu/constant";
import { initializeStripePayment } from "../services/NewServices";
import { formatCurrency } from "../services/Utils";
import { Link } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import StripeForm from "../components/StripeForm";
import { loadStripe } from "@stripe/stripe-js";
import QalortButton from "../components/Button";

function Payment({
  modalVisible,
  setModalVisible,
  itemInfo,
  title,
  cart,
  onPaymentSuccess,
  stripe_success_url,
  stripe_cancel_url,
}) {
  const paymentOptions = [
    // "paystack",
    "stripe",
  ];
  const stripe_key = `${process.env.REACT_APP_STRIPE_KEY}`;
  const REACT_APP_CDN = `${process.env.REACT_APP_CDN}`;
  const [clientSecret, setClientSecret] = useState(null);
  const [showStripePayment, setShowStripePayment] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeMobileScreen, setActiveMobileScreen] = useState("CartDetails");
  const [whatTab, setWhatTab] = useState(0);
  const qalortUser = useSelector((state) => state.user.userData);

  const config = {
    reference: cart?.reference, // new Date().getTime().toString(),
    email: qalortUser?.email,
    amount: cart?.total, //Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
    publicKey: paystack_key,
  };
  const initializePayment = usePaystackPayment(config);

  const onSuccess = (reference) => {
    onPaymentSuccess(reference);
  };

  const onClose = () => {
    console.log("closed");
  };

  const payNow = () => {
    initializePayment({
      onSuccess,
      onClose,
    });
  };

  const makeStripePayment = async () => {
    setLoading(true);
    let data = {
      cart_id: cart?.id,
      payment_option: "stripe",
      cancel_url: stripe_cancel_url,
      success_url: stripe_success_url,
    };
    initializeStripePayment(data)
      .then((res) => {
        setClientSecret(res.data.data.client_key);
      })
      .catch((error) => {
        notification.error({
          description:
            error?.response?.data?.message ||
            "An error occured, Please try again",
        });
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    !!clientSecret && setShowStripePayment(true);
  }, [clientSecret]);

  return (
    <FullModal
      header="Checkout"
      isOpen={modalVisible}
      onClose={() => {
        setModalVisible(false);
      }}
    >
      <div className="mt-8 flex justify-center gap-8 app-container [@media(max-width:984px)]:flex-col-reverse [@media(max-width:984px)]:mt-6">
        <div
          className={`bg-white py-[29px] px-10 w-[590px] rounded-md [@media(max-width:984px)]:bg-transparent [@media(max-width:984px)]:px-0 [@media(max-width:984px)]:w-full ${
            activeMobileScreen === "BillingAddress"
              ? "block"
              : "[@media(max-width:984px)]:hidden"
          }`}
        >
          <div>
            <div className="mt-0">
              <h6
                className="font-semibold mb-0 text-dark"
                data-testid="payment-modal-title"
              >
                Choose Payment Method
              </h6>

              <div className="w-full">
                <div className="flex font-semibold mt-10 [@media(max-width:554px)]:mt-0 mb-6 text-tint overflow-auto [@media(max-width:600px)]:border-t [@media(max-width:600px)]:pt-6 [@media(max-width:600px)]:border-grey-2">
                  {paymentOptions.map((btn, i) => (
                    <div
                      key={i}
                      className={`${
                        i === whatTab && "pri bg-pri-tint"
                      } px-4 py-2 rounded-md pointer text-sm flex-shrink-0`}
                      onClick={() => setWhatTab(i)}
                      data-testid={`payment-option-${btn}`}
                    >
                      {btn}
                    </div>
                  ))}
                </div>
              </div>
              <div className="mt-10 flex items-center justify-center mb-10">
                <div className="w-[130px] h-[130px] flex justify-center items-center bg-pri-tint-3 rounded-full">
                  {/* <img src={whatTab === 0 ? paystack : stripe} alt="icon" /> */}
                  <img src={stripe} alt="icon" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`mt-[29px] [@media(max-width:984px)]:mt-0 ${
            activeMobileScreen === "CartDetails"
              ? "block"
              : "[@media(max-width:984px)]:hidden"
          }`}
        >
          <h6 className="mb-0 font-medium text-dark">Cart Details</h6>
          <div className="mt-4 bg-white [@media(max-width:984px)]:p-2.5 p-4 flex [@media(max-width:984px)]:gap-[15px] gap-5 border-light rounded-lg shadow-3">
            <div className="w-[135px] h-[120px] bg-gray-600 rounded-lg overflow-hidden [@media(max-width:984px)]:max-w-[111px]">
              <img src={itemInfo.banner} alt="" className="w-full" />
            </div>
            <div>
              <p className="p-sm mb-0 max-w-[294px] text-main font-semibold [@media(max-width:984px)]:text-[12px] [@media(max-width:984px)]:leading-5">
                {title}
              </p>
              <p className="p-xs my-3 text-tint [@media(max-width:984px)]:text-[12px] [@media(max-width:984px)]:leading-5">
                {itemInfo.title}
              </p>
              <div className="flex justify-between items-center">
                {/* <div className="flex items-center gap-2">
                  <div className="w-7 h-7 flex justify-center items-center bg-green rounded-md rounded-tl-none">
                    <p className="p-2xs text-white mb-0">4.5</p>
                  </div>
                  <p className="p-2xs text-light mb-0">32,909 ratings</p>
                </div> */}
                <h6 className="pri mb-0 [@media(max-width:984px)]:text-base [@media(max-width:984px)]:leading-7">
                  {itemInfo?.currency}
                  {formatCurrency(cart?.total / 100)}
                </h6>
              </div>
            </div>
          </div>

          <div className="border-t border-light-color pt-[25px] mt-8 [@media(max-width:984px)]:mt-6 [@media(max-width:984px)]:pt-0 [@media(max-width:984px)]:border-0">
            <h6 className="mb-4 text-dark font-medium">Summary</h6>
            <div className="flex flex-col gap-[18px] mb-[13px] [@media(max-width:984px)]:mb-8">
              <div className="flex justify-between items-center">
                <div className="bg-white py-2 px-4 flex items-center gap-4 border-pri shadow-5 rounded-md">
                  <p className="p-sm mb-0 text-main font-medium">PROMO</p>
                  <div className="w-5 h-5 flex justify-center items-center bg-green rounded-full">
                    <img src={tick} alt="" />
                  </div>
                </div>
                <p className="p-sm text-tint mb-0 font-medium">
                  {itemInfo?.currency}0.00
                </p>
              </div>
              <div className="flex justify-between items-center">
                <p className="p-sm text-tint mb-0 font-medium">
                  Original Price
                </p>
                <p className="p-sm text-tint mb-0 font-medium">
                  {itemInfo?.currency}
                  {cart?.total / 100}
                </p>
              </div>
              <div className="flex justify-between items-center">
                <p className="p-sm text-main mb-0 font-semibold">Total</p>
                <p className="p-sm text-main mb-0 font-semibold">
                  {itemInfo?.currency}
                  {cart?.total / 100}
                </p>
              </div>
            </div>
            <p className="p-2xs max-w-[445px] mb-4 text-light font-medium">
              {" "}
              Qalort is required by law to collect applicable transaction taxes
              for purchases made in certain tax jurisdictions. By completing the
              purchase you agree to these{" "}
              <Link to="/terms">
                <span className="pri">Terms & Conditions.</span>
              </Link>
            </p>

            <QalortButton
              data-testid="payment-btn"
              onClick={
                paymentOptions[whatTab] === "paystack"
                  ? payNow
                  : makeStripePayment
              }
              className={`${
                paymentOptions[whatTab] === "paystack" ? "bg-green" : "bg-pri"
              } w-full py-4 text-white rounded-md font-semibold`}
              loading={loading}
            >
              Proceed with Payment
            </QalortButton>

            {/* <button
              data-testid="paymet-btn-mobile"
              className={`${
                paymentOptions[whatTab] === "paystack" ? "bg-green" : "bg-pri"
              } w-full py-4 text-white rounded-md bg-pri-tint-4 font-semibold hidden [@media(max-width:984px)]:block`}
              onClick={() => {
                setActiveMobileScreen("BillingAddress");
              }}
            >
              Proceed with Payment
            </button> */}
          </div>
        </div>
      </div>

      <Modal
        onCancel={() => {
          setShowStripePayment(false);
        }}
        footer={null}
        open={showStripePayment}
      >
        <Elements
          stripe={loadStripe(stripe_key)}
          options={{ clientSecret, locale: "us" }}
        >
          <StripeForm stripe_success_url={stripe_success_url} cart={cart} />
        </Elements>
      </Modal>
    </FullModal>
  );
}

export default Payment;
